export default "__VITE_ASSET__BnAPHzfD__"